<swiper [config]="swiperConfig" [(index)]="swiperIndex" class="swiper-slideshow"
    [ngClass]="{'ninja-like': !(banners.length > 0 && swiperConfig && loaded)}">
    <div swiperSlide class="mx-3" *ngFor="let banner of banners">

        <!-- Cocarda Free-->
        <div class="tarjeta__cocarda" *ngIf="banner.isFree">
            <div class="tarjeta__cocarda-line">
                GRATIS
            </div>
        </div>
        <!-- Cocarda Estreno-->
        <div class="tarjeta__cocarda" *ngIf="banner.esEstreno">
            <div class="tarjeta__cocarda-line line-estreno">
                ESTRENO
            </div>
        </div>
        <!-- Cocarda Sala-->
        <div class="tarjeta__cocarda" *ngIf="banner.esCinema">
            <div class="tarjeta__cocarda-line line-salas">
                EN SALAS
            </div>
        </div>

        <img class="d-block w-100" [src]="banner.base64Img" alt="First slide" />
        <div class="contenedorInfo">
            <div class="row w-100 rowparent">
                <div class="col-12 col-md-9 p-0">
                    <a class="info" (click)="onClickInfo($event, banner)" href="{{banner.url}}">
                        <h1 class=" titulo">{{banner.title}}</h1>
                        <p class="sinopsis" [innerHTML]="banner.synopsis"> </p>
                    </a>
                </div>
                <div class="col-12 col-md-3 p-0 parentbutton">
                    <a class="btn btn-light text-dark masinfo p-2" (click)="onClickInfo($event, banner)">
                        <i class="fas fa-plus mr-2"></i> Más información
                    </a>
                </div>
            </div>
        </div>
    </div>
</swiper>